import { NotificationEntry } from "./Notification";

export interface StreamMessage {
    type: string
    id: string
    notification: NotificationEntry
}

export default class Stream<T> {
    private handler: EventSource

    constructor(endpoint: string, handler: (msg: T) => void) {
        this.handler = new EventSource(endpoint)
        this.handler.onmessage = this.onmesage(handler);
        this.handler.onopen = this.onopen;
        this.handler.onerror = this.onerror;
    }

    close() {
        if(this.handler) {
            this.handler.close();
        }
    }

    private onmesage(handler: (msg: T) => void): ((event: MessageEvent) => void) {
        return (event: MessageEvent) => {
            try {
                const msg = JSON.parse(event.data);
                handler(msg)
            } catch(e) {
                console.error(e);
            }
        }
    }
    private onerror() {
        // code on error
    }
    private onopen() {
        // code on open
    }
}